import React, { CSSProperties, ReactElement, ReactNode, useState } from 'react';
import { ArrayHelpers } from 'formik';
import CreerJourneePedagogique from './CreerJourneePedagogique';
import DetailsJourneePedagogique from './DetailsJourneePedagogique';
import { JourneePedagogique } from '../../../../../common/src/entities';
import ChampMultiple from '../../Common/ChampMultiple';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import { BiPencil, BiX, BiNote } from 'react-icons/all';
import TooltipSimple from '../../Common/TooltipSimple';
import PopoverSimple from '../../Common/PopoverSimple';
import { CopierPressePapier } from '../Utils/CopierPressePapier';
import { cssTexte } from '../constantes';

function AffichageAjout(props: { helpers: ArrayHelpers; values: JourneePedagogique[] }): ReactElement {
    const [showModal, setShowModal] = useState(false);
    const formProps = {
        modal: true,
        succes: (t: JourneePedagogique) => {
            props.helpers.push(t);
            setShowModal(false);
        },
    };
    return (
        <>
            <Button variant="outline-primary" size="sm" onClick={() => setShowModal(true)}>
                Ajouter une journée
            </Button>
            <Modal
                show={showModal}
                onHide={() => {
                    setShowModal(false);
                }}
            >
                <CreerJourneePedagogique {...formProps} {...props.values.length} />
            </Modal>
        </>
    );
}
const affichageAjout = (values: JourneePedagogique[], helpers: ArrayHelpers) => (
    <AffichageAjout helpers={helpers} values={values} />
);

const AffichageElement = (props: {
    value: JourneePedagogique;
    index: number;
    helpers: ArrayHelpers;
    affichageTexte: (value: JourneePedagogique) => ReactNode;
}): ReactElement => {
    const { value, index, helpers, affichageTexte } = props;
    const { remove, replace } = helpers;
    const [showModal, setShowModal] = useState(false);
    const formProps = {
        id: value.id,
        valeursInitiales: value,
        modal: true,
        succes: (t: JourneePedagogique) => {
            replace(index, t);
            setShowModal(false);
        },
    };
    const notesIcone = (
        <CopierPressePapier texte={value.notes}>
            <PopoverSimple texte={value.notes} titre="Notes">
                <BiNote />
            </PopoverSimple>
        </CopierPressePapier>
    );

    const dateFormat = new Date(((value.date + 'T00:00:00') as unknown) as Date).toLocaleString('fr-FR', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
    });
    const flottante = value.type_flottant ? '(' + value.type_flottant + ')' : null;

    return (
        <Row>
            <Col className="d-flex align-items-center">
                <Button variant="link" size="sm" onClick={() => setShowModal(true)}>
                    <BiPencil size="1.25em" />
                </Button>
                <span style={cssTexte}>
                    {dateFormat} {flottante} {notesIcone}
                </span>
            </Col>
            <Col xs="auto">
                <TooltipSimple texte="Supprimer">
                    <Button
                        variant="link"
                        className="d-none d-sm-flex align-items-center text-muted px-0"
                        onClick={() => remove(index)}
                    >
                        <BiX size="1.25em" />
                    </Button>
                </TooltipSimple>
            </Col>
            <Modal
                scrollable
                show={showModal}
                onHide={() => {
                    setShowModal(false);
                }}
            >
                <DetailsJourneePedagogique {...formProps} />
            </Modal>
        </Row>
    );
};

const affichageElement = (
    value: JourneePedagogique,
    index: number,
    helpers: ArrayHelpers,
    affichageTexte: (value: JourneePedagogique) => ReactNode,
) => <AffichageElement {...{ value, index, helpers, affichageTexte }} />;

interface PropsChampMultipleJourneePedagogique {
    id: string;
    labelCol?: number;
}

export default function ChampMultipleJourneePedagogique(props: PropsChampMultipleJourneePedagogique): ReactElement {
    return (
        <ChampMultiple
            entite={JourneePedagogique}
            titre="Date(s)"
            {...props}
            affichageAjout={affichageAjout}
            affichageElement={(
                value: JourneePedagogique | number,
                index: number,
                helpers: ArrayHelpers,
                affichageTexte: (value: JourneePedagogique) => ReactNode,
            ) => affichageElement(value as JourneePedagogique, index, helpers, affichageTexte)}
            labelCol={props.labelCol}
        />
    );
}
